import React from 'react';
import NavLink from './NavLink';
export default function MenuItem({ item, className = '', onClick, ...props }) {
  const defaultClassName = 'font-segoe font-regular text-md leading-[36.44px] align-middle text-[#0A0A0AB2] px-3 py-2 hover:text-[#FF8D28] transition-colors cursor-pointer';
  
  return (
    <NavLink 
      to={item.to} 
      className={`${defaultClassName} ${className}`}
      onClick={onClick}
      {...props}
    >
      {item.label}
    </NavLink>
  );
}
